import { pick, values, get, debounce, min, max, chain } from "lodash"


const A = 4.75439 * (10 ** 7)
const gamma = 0.681456
const { abs } = Math


export function objectifyPosition(position) {
  return {
    timestamp: position.timestamp,
    coords: {
      accuracy: position.coords.accuracy,
      altitude: position.coords.altitude,
      altitudeAccuracy: position.coords.altitudeAccuracy,
      heading: position.coords.heading,
      latitude: position.coords.latitude,
      longitude: position.coords.longitude,
      speed: position.coords.speed
    }
  }
}
  
export const checkboxLabelStyle = disabled => (
  disabled
    ? { fontWeight: "normal", color: "grey", textDecoration: "line-through" }
    : { fontWeight: "normal" }
)
  
const rad = x => (x * Math.PI) / 180
  
function distance(origin, destination) {
  const R = 6371e3; // metres
  const φ1 = rad(origin[0])
  const φ2 = rad(origin[0])
  const Δφ = rad(destination[0] - origin[0])
  const Δλ = rad(destination[1] - origin[1])
  
  const a = (
    (Math.sin(Δφ / 2) * Math.sin(Δφ / 2))
        + (Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2))
  )
  
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  
  const d = R * c
  return d
}

export function getZoom(originCoords, destinationCoords) {
  return -Math.log((distance(originCoords, destinationCoords) * 2.4) / A) / gamma
}
  

export function getRegionForCoordinates(points, options = {}) {
  // points should be an array of { latitude: X, longitude: Y }
  
  const marginFactor = options.marginFactor || 1.06
  const maxDelta = (options.center && options.maxDelta) || Infinity
  const center = options.center || null
  
  const filterPoints = !center ? points : points.filter(p => (
    abs(p[0] - center.latitude) < maxDelta
        && abs(p.longitude - center.longitude) < maxDelta
  ))
  
  const latitudes = filterPoints.map(p => p[0])
  const longitudes = filterPoints.map(p => p[1])
  
  const minX = min(latitudes)
  const maxX = max(latitudes)
  const minY = min(longitudes)
  const maxY = max(longitudes)
  
  return {
    latlng: [(minX + maxX) / 2, (minY + maxY) / 2],
    latitude: (minX + maxX) / 2,
    longitude: (minY + maxY) / 2,
    latitudeDelta: Math.min((maxX - minX) * marginFactor, maxDelta),
    longitudeDelta: Math.min((maxY - minY) * marginFactor, maxDelta),
  }
}





// WEBPACK FOOTER //
// ./src/app/catalogo/transportation/transportation.js